import React ,{useState}from "react";
import SearchBar from "../../components/universal/SearchBar";
import { allchurchHeader } from "./Contants";
import CustomTable from "../../components/universal/CustomTable";
import { AiOutlinePlus } from "react-icons/ai";
import { Link, useNavigate } from "react-router-dom";
import { AllChurchHooks } from "./hooks/Programhooks";
import Navbar from "../../components/universal/Navbar";
import { confirmAlert } from "react-confirm-alert"; // Import
import "react-confirm-alert/src/react-confirm-alert.css";
import ConfirmToast from "../../components/universal/ConfirmToast";
import LoaderSpinner from "../../components/universal/LoaderSpinner";
import { useSelector } from "react-redux";
import ChurchModal from "./ProgramModal";
import { toast } from "react-toastify";
function AllVideos({church}) {
  const navigate = useNavigate();
  const { value, onChangeSearchBar, handleDelete, reloadData, setReloadData,fetchAllChurches } =
  AllChurchHooks();
     const [isModalOpen, setIsModalOpen] = useState(false); // ✅ modal state
  const [selectedRow, setSelectedRow] = useState(null); // store clicked row
 const churches = useSelector((state) => state.churches.churches);
  const [selectedChurchId, setSelectedChurchId] = useState("");
  return (
    <>
    {
      church?
    <div className="App bg-[#191919] ">
    {/* // h-fit min-h-screen flex p-4"> */}
      {/* <Navbar /> */}
      {/* <div className="flex-1 md:pl-32 md:pt-0 pt-20">
        <div className="flex flex-col gap-4 h-full">
          <SearchBar placeholder={"Search"} value={value} onChangeSearchBar={onChangeSearchBar} />
          <div className="MAIN-CONTENT flex-1 flex flex-col h-full gap-4">
            <div className="flex w-full justify-between md:items-center md:flex-row flex-col gap-4 md:mb-0 mb-2">
              <p className=" text-white text-3xl font-medium">Churches</p>
              <div className="flex gap-4">
                <Link to={"/churches/add"}>
                  <button className="flex items-center gap-2 text-[13px] text-yellowish border px-4 py-2 border-yellowish bg-blackish rounded-xl">
                    <AiOutlinePlus /> Add Church
                  </button>
                </Link>
              </div>
            </div> */}
            <div className="relative p-4">
              <div className="flex gap-4 absolute right-4 mt-2">

                                          <button
                                                        onClick={() => setIsModalOpen(true)}
                                                        className=" flex items-center gap-2 text-[13px] text-yellowish border px-4 py-2 border-yellowish bg-blackish rounded-xl"
                                                      >
                                                        <AiOutlinePlus /> Add Program
                                                      </button>
                                                      </div>
                            {
                              !isModalOpen?
              <CustomTable
                searchFor="Programs"
                heightDesktop={"h-[72vh]"}
                width={"w-24"}
                // giving extra width to 2nd column
                nthChildWidth={
                  "[&>*:nth-child(1)]:w-40 [&>*:nth-child(2)]:w-40 [&>*:nth-child(3)]:w-40 [&>*:nth-child(3)]:w-32"
                }
                notificationTable={true}
                data={[]}
                headers={allchurchHeader}
                customDataFetch={true}
                customDataFetchFunction={(page, limit, searchCriteria, callback) =>
                  fetchAllChurches(page, limit, searchCriteria, callback, church?._id)
                }
                reloadData={reloadData}
                setReloadData={setReloadData}
                handleDeleteClick={(row) => {
                  const options = {
                    customUI: ({ onClose }) => (
                      <ConfirmToast
                        title="Are you sure?"
                        message="You want to delete this Program?"
                        onClose={onClose}
                        onSuccess={async () => {
                          try {
                            const res = await handleDelete(row);  // res is the callback object from saga
                             // safe
                            setReloadData((prev) => !prev); // refresh table
                            toast.success( "Program Deleted");

                            onClose();
                          } catch (err) {
                            // Always null-check err and its properties
                                                        toast.error(err?.error || "Delete failed");
                            onClose();
                          }
                        }}

                      />
                    ),
                    closeOnEscape: true,
                    closeOnClickOutside: true,
                    keyCodeForClose: [8, 32],
                    overlayClassName: "!bg-gray-500 !bg-opacity-75",
                  };

                  confirmAlert(options);
                }}

                reverseTable={true}
                nthChildStyle={"[&>*:nth-child(2)]:h-5 [&>*:nth-child(2)]:overflow-hidden"}
                handleToggleClick={(row, isActive) => {
                                  }}
                handleEyeClick={(row) => {
                                    setIsModalOpen(true)
                  setSelectedRow(row);
                  // navigate("/churches/add", {
                  //   state: {
                  //     _id: row?._id || "",
                  //   },
                  // });
                }}
                handleEditClick={(row) => {
                                 setIsModalOpen(true)
               setSelectedRow(row); // store clicked row

                  // navigate("/church/add", {
                  //   state: {
                  //     _id: row?._id || "",
                  //   },
                  // });
                }}
              />
              :''
}
            </div>
    <ChurchModal church={church} isOpen={isModalOpen}    onClose={() => { setIsModalOpen(false); setSelectedRow(null); }} rowData={selectedRow} // ✅ pass clicked row
    />

          </div>
          :
          <div className="w-full h-full flex items-center justify-center text-gray-400 ">
             <p>Add Church/Ministry/Channel First</p>

          </div>
}
          </>
    //     </div>
    //   </div>
    // </div>
  );
}

export default AllVideos;
